import { Component, OnInit, AfterViewInit, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';
import { DateFilterValue } from '../helpers/date-filter/date-filter.component';
import { SalesPerformanceDashboardService } from 'src/app/services/dashboard/sales-performance-dashboard.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sales-performance',
  templateUrl: './sales-performance.component.html',
  styleUrls: ['./sales-performance.component.css']
})
export class SalesPerformanceComponent implements OnInit{
  public isLoading: boolean = false;

  recentOffersPage: number = 1;
  recentOffersCount: number = 0;
  searchRecentOffersText: string = '';
  recentSaleOffers: any[] = [];

  salesRepsPerformancePage: number = 1;
  salesRepsPerformanceCount: number = 0;
  searchsalesRepsPerformanceText: string = '';
  salesRepsPerformance: any[] = [];
  salesRepsPerformanceSelectedPeriod = 'current_month';

  private customerCategoryData = {
    labels: [] as string[],
    values: [] as number[],
    colors: ['#ffc107', '#ff0000', '#28a745']
  };

  private customerTypeData = {
    labels: [] as string[],
    values: [] as number[],
    colors: ['#007bff', '#ff0000', '#fd7e14']
  };

  salesOffersSelectedPeriod = 'current_month';

  private branchPerformanceData = {
    labels: [] as string[],
    offers: [] as number[],
    sales:  [] as number[],
  };

  branchPerformanceSelectedPeriod = 'current_month';

  @ViewChild('categoryPieCanvas') categoryPieCanvasRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('typeDonutCanvas') typeDonutCanvasRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('branchBarCanvas') branchBarCanvasRef!: ElementRef<HTMLCanvasElement>;

  private categoryPieChart?: Chart;
  private typeDonutChart?: Chart;
  private branchBarChart?: Chart;

  constructor(
    private salesPerformanceDashboardService: SalesPerformanceDashboardService,
    private toastr: ToastrService,
  ){}

  ngOnInit(): void {
    this.fetchRecentOffers();
    this.loadSalesRepsPerformance(this.salesRepsPerformanceSelectedPeriod);
    this. loadSaleOffersByCustomerCategory(this.salesOffersSelectedPeriod);
    this.loadSaleOffersByCustomerType(this.salesOffersSelectedPeriod);
    this.loadSalesPerformanceByBranch(this.branchPerformanceSelectedPeriod);
  }

  onRepsFilterChange(filter: DateFilterValue): void {
    if(filter.type=='thisMonth'){
      this.salesRepsPerformanceSelectedPeriod = 'current_month';
      this.loadSalesRepsPerformance(this.salesRepsPerformanceSelectedPeriod);
    }else if(filter.type=='lastMonth'){
      this.salesRepsPerformanceSelectedPeriod = 'last_month';
      this.loadSalesRepsPerformance(this.salesRepsPerformanceSelectedPeriod);
    }else if(filter.type=='custom'){
      this.salesRepsPerformanceSelectedPeriod='custom&start_date='+filter.startDate+'&end_date='+filter.endDate;
      this.loadSalesRepsPerformance(this.salesRepsPerformanceSelectedPeriod);
    }
  }

  onCategoryTypeFilterChange(filter: DateFilterValue): void {
     if(filter.type=='thisMonth'){
      this.salesOffersSelectedPeriod = 'current_month';
      this.loadSaleOffersByCustomerCategory(this.salesOffersSelectedPeriod);
      this.loadSaleOffersByCustomerType(this.salesOffersSelectedPeriod);
    }else if(filter.type=='lastMonth'){
      this.salesOffersSelectedPeriod = 'last_month';
       this.loadSaleOffersByCustomerCategory(this.salesOffersSelectedPeriod);
      this.loadSaleOffersByCustomerType(this.salesOffersSelectedPeriod);
    }else if(filter.type=='custom'){
      this.salesOffersSelectedPeriod = 'custom&start_date='+filter.startDate+'&end_date='+filter.endDate;
      this.loadSaleOffersByCustomerCategory(this.salesOffersSelectedPeriod);
      this.loadSaleOffersByCustomerType(this.salesOffersSelectedPeriod);

    }
  }

  onBranchFilterChange(filter: DateFilterValue): void {
    if(filter.type=='thisMonth'){
      this.branchPerformanceSelectedPeriod = 'current_month';
      this.loadSalesPerformanceByBranch(this.branchPerformanceSelectedPeriod);
    }else if(filter.type=='lastMonth'){
      this.branchPerformanceSelectedPeriod = 'last_month';
      this.loadSalesPerformanceByBranch(this.branchPerformanceSelectedPeriod);
    }else if(filter.type=='custom'){
      this.branchPerformanceSelectedPeriod = 'custom&start_date='+filter.startDate+'&end_date='+filter.endDate;
      this.loadSalesPerformanceByBranch(this.branchPerformanceSelectedPeriod);
    }
  }

  ngAfterViewInit(): void {
    this.buildCategoryPieChart();
    this.buildTypeDonutChart();
    this.buildBranchBarChart();
  }

  ngOnDestroy(): void {
    // Prevents leaked Chart.js instances / duplicated canvases if this
    // component is destroyed and recreated (e.g. navigating away and back).
    this.categoryPieChart?.destroy();
    this.typeDonutChart?.destroy();
    this.branchBarChart?.destroy();
  }

  private buildCategoryPieChart(): void {
    if (this.categoryPieChart) {
      this.categoryPieChart.destroy();
    }

    this.categoryPieChart = new Chart(this.categoryPieCanvasRef.nativeElement, {
      type: 'pie',
      data: {
        labels: this.customerCategoryData.labels,
        datasets: [{
          data: this.customerCategoryData.values,
          backgroundColor: this.customerCategoryData.colors,
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom' },
          title: {
              display: true,
              text: 'Offers by Customer Category'
          }
        }
      }
    });
  }

  private buildTypeDonutChart(): void {
    if (this.typeDonutChart) {
      this.typeDonutChart.destroy();
    }

    this.typeDonutChart = new Chart(this.typeDonutCanvasRef.nativeElement, {
      type: 'doughnut',
      data: {
        labels: this.customerTypeData.labels,
        datasets: [{
          data: this.customerTypeData.values,
          backgroundColor: this.customerTypeData.colors,
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%',
        plugins: {
          legend: { position: 'bottom' },
          title: {
              display: true,
              text: 'Offers By Customer Type'
          }
        }
      }
    });
  }

  private buildBranchBarChart(): void {
    this.branchBarChart = new Chart(this.branchBarCanvasRef.nativeElement, {
      type: 'bar',
      data: {
        labels: this.branchPerformanceData.labels,
        datasets: [
          {
            label: 'Offers',
            data: this.branchPerformanceData.offers,
            backgroundColor: '#ff0000'
          },
          {
            label: 'Sales',
            data: this.branchPerformanceData.sales,
            backgroundColor: '#28a745'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: { precision: 0 }
          }
        },
        plugins: {
          legend: { position: 'bottom' }
        }
      }
    });
  }

  /**
   * Get recent offers i.e offers posted today
   */
  fetchRecentOffers():void{
      this.isLoading=true;

      this.salesPerformanceDashboardService.getRecentSaleOffers().subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.isLoading=false;
            this.recentSaleOffers = response.data
          }else{
            this.isLoading=false;
            this.toastr.warning(response.message, 'Warning!');
          }
        },
        error: (error) => {
          this.isLoading=false;
          this.toastr.error(error, 'Error!');
        }
      });
    }

    recentOffersPageChangeEvent(event: number){
      this.recentOffersPage = event;
      this.fetchRecentOffers();
    }

    recentOffersOnSearchTextChange(event: Event) {
      this.searchRecentOffersText = (event.target as HTMLInputElement).value;
    }

    /**
     * Load sales performance by sales reps
     * based on the selected period
     * @param selectedPeriod
     */
    loadSalesRepsPerformance(selectedPeriod: string):void{
      this.isLoading=true;

      this.salesPerformanceDashboardService.getSalesRepsPerformance(selectedPeriod).subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.isLoading=false;
            this.salesRepsPerformance = response.data
          }else{
            this.isLoading=false;
            this.toastr.warning(response.message, 'Warning!');
          }
        },
        error: (error) => {
          this.isLoading=false;
          this.toastr.error(error, 'Error!');
        }
      });
    }

  salesRepsPerformancePageChangeEvent(event: number){
    this.salesRepsPerformancePage = event;
    this.loadSalesRepsPerformance(this.salesRepsPerformanceSelectedPeriod);
  }

  salesRepsPerformanceOnSearchTextChange(event: Event) {
    this.searchsalesRepsPerformanceText = (event.target as HTMLInputElement).value;
  }

  /**
   * Load sale offers by customer category
   * based on the selected period
   * @param selectedPeriod
   */
  loadSaleOffersByCustomerCategory(selectedPeriod: string):void{
    this.isLoading=true;

    this.salesPerformanceDashboardService.getSaleOffersByCustomerCategory(selectedPeriod).subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isLoading=false;
            this.customerCategoryData = {
            ...this.customerCategoryData,
            labels: response.data.labels,
            values: response.data.values
          };

          this.updateCategoryPieChart();
        }else{
          this.isLoading=false;
          this.toastr.warning(response.message, 'Warning!');
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  private updateCategoryPieChart(): void {
    if (!this.categoryPieChart) {
      return;
    }

    this.categoryPieChart.data.labels =
      this.customerCategoryData.labels;

    this.categoryPieChart.data.datasets[0].data =
      this.customerCategoryData.values;

    this.categoryPieChart.data.datasets[0].backgroundColor =
      this.customerCategoryData.colors;

    this.categoryPieChart.update();
  }

  /**
   * Load sale offers by customer type
   * based on the selected period
   * @param selectedPeriod
   */
  loadSaleOffersByCustomerType(selectedPeriod: string):void{
    this.isLoading=true;

    this.salesPerformanceDashboardService.getSaleOffersByCustomerType(selectedPeriod).subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isLoading=false;
            this.customerTypeData = {
            ...this.customerTypeData,
            labels: response.data.labels,
            values: response.data.values
          };

          this.updateTypeDonutChart();
        }else{
          this.isLoading=false;
          this.toastr.warning(response.message, 'Warning!');
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  private updateTypeDonutChart(): void {
    if (!this.typeDonutChart) {
      return;
    }

    this.typeDonutChart.data.labels =
      this.customerTypeData.labels;

    this.typeDonutChart.data.datasets[0].data =
      this.customerTypeData.values;

    this.typeDonutChart.data.datasets[0].backgroundColor =
      this.customerTypeData.colors;

    this.typeDonutChart.update();
  }

  /**
   * Load sales performance by branch
   * based on the selected period
   * @param selectedPeriod
   */
  loadSalesPerformanceByBranch(selectedPeriod: string): void {
    this.isLoading = true;

    this.salesPerformanceDashboardService
      .getSalesPerformanceByBranch(selectedPeriod)
      .subscribe({
        next: (response) => {
          this.isLoading = false;

          if (response.status === 'success') {
            this.branchPerformanceData = {
              ...this.branchPerformanceData,
              labels: response.data.labels,
              offers: response.data.offers,
              sales: response.data.sales
            };

            this.updateBranchPerformanceChart();
          } else {
            this.toastr.warning(response.message, 'Warning!');
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.toastr.error(error, 'Error!');
        }
      });
  }

  private updateBranchPerformanceChart(): void {
    if (!this.branchBarChart) {
      return;
    }

    this.branchBarChart.data.labels =
      this.branchPerformanceData.labels;

    this.branchBarChart.data.datasets[0].data =
      this.branchPerformanceData.offers;

    this.branchBarChart.data.datasets[1].data =
      this.branchPerformanceData.sales;

    this.branchBarChart.update();
  }
}
